import withWidth, { isWidthUp } from '@material-ui/core/withWidth'
import queryString from 'query-string'
import '../../../../../assets/stylesheets/application.scss'
import { locationLookup } from '../../helpers'
import { loadFragments } from '../../store'
import { MapComponent, Loading, SignUp } from '../../components'
import * as Section from './Sections'
import { CTA_TYPE, GOOGLE_API_KEY, SHOW_STORIES } from '../../constants'
import useStyles from './styles'

const Results = (props) => {
  const desktop = isWidthUp('md', props.width)
  const dispatch = useDispatch()
  const fragments = useSelector((state) => state.local.fragments)
  const classes = useStyles({ ...props, desktop })
  const [coords, setCoords] = useState({})
  const [results, setResults] = useState({})
  const [signedUp, setSignedUp] = useState(false)
  const { postcode, constituency } = results || {}

  useEffect(() => {
    dispatch(loadFragments())
  }, [])

  useEffect(() => {
    /* Get location/postcode from URL query string & lookup data */
    init()
  }, [])

  const init = async () => {
    // Set google map location directly
    const parsed = queryString.parse(location.search)
    if (!parsed.postcode && !!parsed.lat && !!parsed.lng) {
      setCoords(_.pick(parsed, ['lat', 'lng']))
    }

    const res = await locationLookup()
    if (!res || (res && !res.constituency)) window.location.href = '/'
    // Set google map location from lookup
    if (_.isEmpty(coords)) setCoords(res.location)
    // Save data
    setResults(res)
  }

  const getCtaSection = (type = CTA_TYPE) => {
    switch (type) {
      case 'donate':
        return <Section.Donate {...{ fragments, postcode }} />
      case 'email':
      case 'petition':
      case 'devolved':
      case 'by_election':
        return <Section.Action {...{ fragments, postcode, constituency }} />
    }
  }

  return (
    <div>
      <Loading show={_.isEmpty(fragments) || !results} page light />
      <Fade in={!_.isEmpty(fragments) && !!results} timeout={500}>
        <Container maxWidth={false} disableGutters>
          <Grid container direction="column">
            <Grid item xs={12} className={classes.gridMap}>
              {!!GOOGLE_API_KEY && (
                <MapComponent
                  coords={coords}
                  apiKey={GOOGLE_API_KEY}
                  constituency={results?.constituency}
                />
              )}
            </Grid>
            <Grid item container xs={12} className={classes.gridClear}>
              <Section.LocationStats {...{ results }} />
            </Grid>
            {!!results && (
              <Grid item container xs={12} className={classes.gridBg}>
                {getCtaSection(results?.constituency?.action)}
              </Grid>
            )}

            <Grid item container xs={12} className={classes.signupBg} justify="center">
              <Section.Share {...{ constituency, fragments }} />
            </Grid>

            {SHOW_STORIES && <Section.ShowStories {...{ fragments, coords, results }} />}
            <Grid item container xs={12} className={classes.gridClear}>
              <Section.TellStory {...{ fragments }} />
            </Grid>
            <Grid item container xs={12} className={classes.gridBg}>
              <Grid item container className={classes.signupBg} justify="center">
                <SignUp linkOnly />
                {signedUp && (
                  <Fade in>
                    <Grid
                      item
                      xs={12}
                      style={{ textAlign: 'center', margin: '-30px 0 30px 0' }}
                    >
                      <Button variant="contained" color="secondary" href="/get_involved">
                        get involved
                      </Button>
                    </Grid>
                  </Fade>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Fade>
    </div>
  )
}

export default withWidth()(Results)
